import script from "./compare-table-product-buying-options.vue?vue&type=script&setup=true&lang=js"
export * from "./compare-table-product-buying-options.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__